// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"f494e61b","98":"e7859b9d","110":"85ec2b15","200":"24919b1d","242":"1caee550","302":"e81d8c8f","488":"63a4d92f","490":"1553b91a","530":"213ff88e","572":"558780e3","638":"e19c96d7","745":"e2105c1c","772":"86ddd1a2","937":"b077853c"}[chunkId] + ".chunk.js";
};